import React from "react";
import { Button, ButtonProps, Heading, Modal, ModalProps } from "@hex-insights/core";
import { SocialCommentFilterInput, useSocialCommentListQuery } from "../../../../Utilities";
import { CommentsList } from "../General";

export type SocialCommentsListModalControllerProps = Omit<ButtonProps, "onClick"> &
	Pick<SocialCommentsListModalProps, "filters" | "heading">;

export function SocialCommentsListModalController({
	filters,
	heading,
	...props
}: SocialCommentsListModalControllerProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<Button {...props} onClick={openModal} />

			<Modal.If condition={isModalOpen}>
				<SocialCommentsListModal heading={heading} filters={filters} onClose={closeModal} />
			</Modal.If>
		</React.Fragment>
	);
}

export type SocialCommentsListModalProps = Pick<ModalProps, "ifRef" | "onClose"> & {
	heading?: JSX.Element | string;
	filters?: SocialCommentFilterInput | null;
};

export function SocialCommentsListModal({
	filters,
	heading = "Social Comments",
	ifRef,
	onClose,
}: SocialCommentsListModalProps) {
	const { data } = useSocialCommentListQuery({ variables: { filters } });
	const comments = React.useMemo(() => data?.socialCommentConnection.edges.map((edge) => edge.node) ?? [], [data]);

	// TODO scroll pagination

	return (
		<Modal ifRef={ifRef} onClose={onClose} style={{ height: "40rem" }}>
			<Modal.Header>
				<Heading.H2 noMargin>{heading}</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<CommentsList comments={comments} />
			</Modal.Body>
		</Modal>
	);
}
